module.exports = __webpack_public_path__ + "img/img_mainland_account_open_10.92aca71f.png";